export default "__VITE_ASSET__BpSP2AJu__"